module.exports = __webpack_public_path__ + "static/media/dhakani_dhah.edc6f9bf.ogg";